import { TransactionActions, TransactionStateType } from './transactionTypes';

const transactionReducer = (
    state: TransactionStateType,
    action: TransactionActions
): TransactionStateType => {
    switch (action.type) {
        case 'ADD_PENDING_TRANSACTION':
            return {
                ...state,
                pendingTransactions: [action.payload, ...state.pendingTransactions],
            };
        case 'REMOVE_PENDING_TRANSACTION':
            return {
                ...state,
                pendingTransactions: state.pendingTransactions.filter(({ sigHash }) => {
                    if (sigHash === action.payload && action.callback) {
                        action.callback();
                    }

                    return sigHash !== action.payload;
                }),
            };
        default:
            return state;
    }
};

export default transactionReducer;
